document.addEventListener("DOMContentLoaded", function() {
    const radioInputs = document.querySelectorAll('.block-swatch__radio[name="option1"]');
    const priceContainer = document.querySelector('[data-product-price-list]');

    // Check if elements exist
    if (!radioInputs.length || !priceContainer) return;

    const loggedInPrices = {
        '100g': '17.00',
        '300g': '37.00'
    };

    const nonLoggedInPrices = {
        '100g': '30.00', // This will be replaced by the server with the actual price
        '300g': '74.00'
    };

    // Check if the user is logged in
    const body = document.querySelector('body');
    const userIsLoggedIn = body.getAttribute('data-user-logged-in') === 'true';
    
    const pricesToUse = userIsLoggedIn ? loggedInPrices : nonLoggedInPrices;

    const overridePricesForVariants = (variantValue) => {
        // If the variant value exists in our prices object, override the innerHTML
        if (pricesToUse[variantValue]) {
            const currentHTML = priceContainer.innerHTML;
            const updatedHTML = currentHTML.replace(/\$\d+\.\d+/g, `$${pricesToUse[variantValue]}`);
            priceContainer.innerHTML = updatedHTML;
        }
    };

    // Attach event listeners to each radio input
    radioInputs.forEach(radio => {
        radio.addEventListener('change', function() {
            // Set a timeout to delay our price override
            setTimeout(() => {
                overridePricesForVariants(this.value);
            }, 100);  // 100ms delay. Adjust if needed.
        });
    });

    // Override prices on initial load
    radioInputs.forEach(radio => {
        if (radio.checked) {
            overridePricesForVariants(radio.value);
        }
    });
});
